export default __webpack_public_path__ + "static/media/SIMTalent2.8ac02e8b.png";